import React, { useState } from 'react';
import './mainPage.css';

function MainPage() {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    const openModal = (imageSrc) => {
        setSelectedImage(imageSrc);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedImage('');
    };

    return (
        <section id="gallery-1716">
            <div class="cs-container">
                <div class="cs-content">
                    <span class="cs-topper">Science of the Sound</span>
                    <h2 class="cs-title">Japa and Kirtan</h2>
                    <p class="cs-text">
                        Think of the mantra like a spiritual "noise-canceling headphone." It doesn't just block out the stress; it replaces the mental "static" with a frequency that feels grounded and peaceful.                    </p>
                    <a href="/krishna-temple-events" class="cs-button-solid">View All</a>
                </div>
                <div class="cs-gallery">
                    <picture class="cs-picture" onClick={() => openModal('images/krishnafeet.jpeg')}>
                        <source media="(max-width: 600px)"
                                srcset="images/krishnafeet.jpeg"></source>
                        <source media="(min-width: 601px)"
                                srcset="images/krishnafeet.jpeg"></source>
                        <img loading="lazy" decoding="async"
                                src="images/krishnafeet.jpeg" alt="picture"
                                width="480" height="549"></img>
                    </picture>
                    {/* <picture class="cs-picture">
                        <source media="(max-width: 600px)"
                                srcset="images/krishnafeet.jpeg"></source>
                        <source media="(min-width: 601px)"
                                srcset="images/krishnafeet.jpeg"></source>
                        <img loading="lazy" decoding="async"
                                src="images/krishnafeet.jpeg" alt="picture"
                                width="480" height="549"></img>
                    </picture> */}
                    <picture class="cs-picture" onClick={() => openModal('images/stressMgmt.jpeg')}>
                        <source media="(max-width: 600px)"
                                srcset="images/stressMgmt.jpeg"></source>
                        <source media="(min-width: 601px)"
                                srcset="images/stressMgmt.jpeg"></source>
                        <img loading="lazy" decoding="async"
                                src="images/stressMgmt.jpeg" alt="picture"
                                width="480" height="549"></img>
                    </picture>
                </div>
            </div>
            {modalOpen && (
                <div class="cs-modal" onClick={closeModal}>
                    <div class="cs-modal-content" onClick={(e) => e.stopPropagation()}>
                        <span class="cs-close" onClick={closeModal}>&times;</span>
                        <img src={selectedImage} alt="modal-image" class="cs-modal-image" />
                    </div>
                </div>
            )}
        </section>
    );
}

export default MainPage;
                                